import React from 'react';
import styles from '../../../gen2_widgets/base/CommonSettings.module.scss';

function CommonRow ({ children, className = '', ...rest }) {
  return (
    <div className={`${styles['settings-row']} ${className}`} {...rest}>
      {children}
    </div>
  )
}

export default CommonRow;